import { getAccessToken } from "../Services/authToken";

export interface PairingExp {
  stage: string;
  submission_group_id: string;
  interview_pairing_id: string;
  slot_booking_id: string | null;
  requisition_id: string;
  candidate_full_name: string;
  interviewer_1_name?: string | null;
  interviewer_2_name?: string | null;
  interviewer_3_name?: string | null;
  interview_number: number;
  total_interviews: string;
  start_time: string;
  end_time: string;
  interviewer_1_id?: string | null;
  interview_1_start_time?: string | null;
  interview_1_end_time?: string | null;
  interview_1_duration?: number | null;
  interviewer_2_id?: string | null;
  interview_2_start_time?: string | null;
  interview_2_end_time?: string | null;
  interview_2_duration?: number | null;
  interviewer_3_id?: string | null;
  interview_3_start_time?: string | null;
  interview_3_end_time?: string | null;
  interview_3_duration?: number | null;
  interview_1_type?: string | null;
  interview_2_type?: string | null;
  interview_3_type?: string | null;
  slot_available: boolean;
  recruiter_email: string;
  recruiter_name: string;
  interview_structure?: string;
  meeting_link: string | null;
  is_assigned: boolean;
}

export interface InterviewPairingsResponseExp {
  requisition_id: string;
  job_title: string;
  interview_paired: boolean;
  pairings: PairingExp[];
}

const hostname = window.location.hostname;

export const getInterviewPairingsExp = async (
  rescheduleClicked: boolean = false
): Promise<InterviewPairingsResponseExp[] | null> => {
  let baseurl = '';
  if (hostname.includes('localhost')) {
    baseurl = 'http://localhost:8080';
  } else if (hostname.includes('dev')) {
    baseurl = 'https://candidateinterviewscheduler-dev.pwc.com';
  } else if (hostname.includes('stg') || hostname.includes('stage')) {
    baseurl = 'https://candidateinterviewscheduler-stg.pwc.com';
  } else {
    baseurl = 'https://candidateinterviewscheduler.pwc.com';
  }

  try {
    const token = await getAccessToken();
    if (!token) {
      console.error('No authentication token available');
      return null;
    }

    // const url = `${baseurl}/api/candidate-dashboard/interview-pairings-exp-2?reschedulePage=${rescheduleClicked}`;
    const url = `${baseurl}/api/candidate-dashboard/interview-pairings-exp-bulk?reschedulePage=${rescheduleClicked}`;
    const res = await fetch(url, {
      method: 'GET',
      headers: { Accept: 'application/json', 'Authorization': `Bearer ${token}` },
    });

    if (!res.ok) {
      throw new Error(`Failed: ${res.status} ${res.statusText}`);
    }

    const data: InterviewPairingsResponseExp[] = await res.json();
    console.log('[API] Fetched experienced interview pairings:', data);
    return data;
  } catch (err) {
    console.error('Error fetching experienced interview pairings:', err);
    return null;
  }
};